<template>
	<field-wrapper v-bind="wrapper">
		<input ref="field" :id="name" :name="name" type="file" @change="onChange" />
		<div class="info" :class="infoClass">
			<template v-if="model">
				<div class="info__icon">
					<icon-error v-if="uploadError" />
					<icon-done v-else />
				</div>
				<span class="info__instructions">{{ filename }}</span>
			</template>
			<template v-else>
				<div class="info__icon">
					<icon-upload />
				</div>
				<span class="info__instructions"
					>Drag to upload, or<br /><span class="link">choose file</span></span
				>
			</template>
		</div>
	</field-wrapper>
</template>

<script>
import FieldWrapper from '@/components/shared/FieldWrapper'
import field from '@/mixins/field'

import IconUpload from 'mdi-vue/CloudUpload'
import iconError from 'mdi-vue/CloudAlert'
import IconDone from 'mdi-vue/CloudCheck'

export default {
	name: 'field-upload',
	methods: {
		onChange({ target }) {
			if (target.files && target.files.length) {
				this.$emit('input', { value: target.files, $dirty: true })
			}
		}
	},
	computed: {
		infoClass() {
			return {
				'info--error': this.error
			}
		},
		filename() {
			if (!this.model || !this.model.length) return ''
			return this.model.item(0).name
		},
		uploadError() {
			return this.errors && this.errors.length
		}
	},
	mixins: [field],
	components: {
		FieldWrapper,
		IconUpload,
		iconError,
		IconDone
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';

input {
	@extend %field;
	height: 10rem;
	opacity: 0;

	// Add focus ring since input is hidden
	&:focus + .info {
		@extend %focus;
	}
}

.info {
	@extend %flex-center;
	background-color: $blue-98;
	pointer-events: none;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;

	&--error {
		color: $orange-95;
	}
	&__icon {
		&,
		svg {
			width: 3rem;
			height: 3rem;
		}
	}

	&__instructions {
		margin-left: 1rem;
		font-size: 0.875rem;
		text-align: center;
		.link {
			font-weight: bold;
			text-decoration: underline;
			white-space: nowrap;
		}
	}
}
</style>
